module.exports = __webpack_public_path__ + "media/images/wines-header-4e0c65d0d5f551dec2788181d58e02f7.jpg";